import { Container, Stack, SwipeableDrawer, Typography, useMediaQuery, useTheme } from "@mui/material";
import * as React from "react";
import { ActivityEnum, AiChatEnum, useUserActivityTracker } from "../UserActivityTracker";
import OfficeHourInterface from "../component/OfficeHourInterface";
import OfficeHourMenu from "../component/OfficeHourMenu";
import AppBarContext, { AppBarMenuIndex } from "../context/AppBarContext";
import { ChatListProvider } from "../context/ChatListContext";

export default function OfficeHour() {

    useUserActivityTracker(ActivityEnum.AiChat, AiChatEnum.OfficeHour)

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const isTouchDevice = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) && window.matchMedia("(pointer: coarse)").matches;

    const { setMenuIndex } = React.useContext(AppBarContext);
    const [isMenuCollapsed, setIsMenuCollapsed] = React.useState(false);

    // Auto-collapse sidebar on mobile screens
    React.useEffect(() => {
        setIsMenuCollapsed(isMobile);
    }, [isMobile]);

    React.useEffect(() => {
        setMenuIndex(AppBarMenuIndex.OfficeHour);
    }, [setMenuIndex]);

    return (
        <ChatListProvider>
            <div
                style={{
                    display: "flex",
                    width: "100%",
                    height: "100%",
                    position: "relative",
                    overflow: "hidden",
                }}>
                {/* Menu */}
                {isTouchDevice ? (
                    <SwipeableDrawer
                        anchor="left"
                        open={!isMenuCollapsed}
                        onClose={() => setIsMenuCollapsed(true)}
                        onOpen={() => setIsMenuCollapsed(false)}
                        disableDiscovery={false}
                        disableSwipeToOpen={false}
                        PaperProps={{
                            sx: { backgroundColor: "#002A6E" },
                        }}
                    >
                        <Container // do not add vertical padding here, otherwise screen height will be wrong. add it inside ConversatioMenu titleHeaderRef component
                            sx={{
                                opacity: isMenuCollapsed ? 0 : 1,
                                transition: "opacity 0.3s ease-in-out",
                            }}>
                            <OfficeHourMenu isMenuCollapsed={isMenuCollapsed} onToggleMenuCollapse={() => setIsMenuCollapsed(!isMenuCollapsed)} isMobile={isMobile} isTouchDevice={isTouchDevice} />
                        </Container>
                        {/* swipe hint footer */}
                        <Stack direction="column" sx={{ width: '100%', color: "#FFFFFFBB", userSelect: "none", display: "flex", alignItems: "center", justifyContent: "center", mb: 2 }}>
                            <Typography>Swipe left to close</Typography>
                            <Typography>Swipe right to open</Typography>
                        </Stack>
                    </SwipeableDrawer>
                ) : (
                    <div
                        style={{
                            width: isMenuCollapsed ? "0" : "33.33%",
                            minWidth: isMenuCollapsed ? "0" : "300px",
                            maxWidth: isMenuCollapsed ? "0" : "33.33%",
                            height: "100%",
                            transition: "all 0.3s ease-in-out",
                            overflow: "hidden",
                            backgroundColor: "#002A6E", // Blue background for sidebar
                            flexShrink: 0,
                        }}>
                        <Container
                            sx={{
                                height: "100%",
                                opacity: isMenuCollapsed ? 0 : 1,
                                transition: "opacity 0.3s ease-in-out",
                            }}>
                            <OfficeHourMenu isMenuCollapsed={isMenuCollapsed} onToggleMenuCollapse={() => setIsMenuCollapsed(!isMenuCollapsed)} isMobile={isMobile} isTouchDevice={isTouchDevice} />
                        </Container>
                    </div>
                )}

                {/* Content */}
                <div
                    style={{
                        width: isMenuCollapsed ? "100%" : "66.67%",
                        transition: "all 0.3s ease-in-out",
                        flexGrow: 1,
                        height: "100%",
                        overflow: "hidden",
                        backgroundColor: "#F2F7FF",
                    }}>
                    <OfficeHourInterface isMenuCollapsed={isMenuCollapsed} onToggleMenuCollapse={() => setIsMenuCollapsed(!isMenuCollapsed)} isMobile={isMobile} />
                </div>
            </div>
        </ChatListProvider>
    );
}
